import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../components/Home'
import Settings from "../components/views/Settings";
import Completed from "../components/views/Completed";
import UnCompleted from "../components/views/UnCompleted";

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/settings',
    name: 'Settings',
    component: Settings
  },
  {
    path: '/completed',
    name: 'Completed',
    component: Completed
  },
  {
    path: '/uncompleted',
    name: 'UnCompleted',
    component: UnCompleted
  }
];

const router = new VueRouter({
  routes,
  mode: 'hash'
});

export default router
